import Icon from "@mkt/ui/components/common/Icon"

export default function ChevronLeft(props) {
  return (
    <Icon
      iconMarkup={`
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.9355 15.1757L4.48774 8.49169C4.41473 8.42348 4.41473 8.28707 4.48774 8.15066L11.9355 1.1936" stroke="" stroke-width="1.02308" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `}
      iconName="ChevronLeft"
      {...props}
    />
  )
}
